<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item label="服务器编号" :required="true">
              <j-dict-select-tag
                v-model="queryParam.serverNo"
                placeholder="请选择服务器编号"
                dictCode="data_sync_service_code"
                :allowClear="false"
              />
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="查询时间" :required="true">
              <a-range-picker
                v-model="dateRange"
                format="YYYY-MM-DD HH:mm"
                :show-time="{ format: 'HH:mm' }"
                style="width: 100%"
                @change="handleDateChange"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="关键词" :required="true">
              <a-input v-model="queryParam.keyword" placeholder="请输入关键词"></a-input>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item label="日志类型">
              <j-dict-select-tag
                v-model="queryParam.logType"
                placeholder="请选择日志类型"
                dictCode="data_sync_sync_type"
                :allowClear="true"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="配置号">
              <a-input v-model="queryParam.configCode" placeholder="请输入配置号"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span style="float: right; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 表格区域 -->
    <div>
      <a-table
        ref="table"
        bordered
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="false"
      >
        <span slot="logType" slot-scope="text">
          {{ text }}
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">详情</a>
        </span>
      </a-table>

      <!-- 自定义分页 -->
      <div class="custom-pagination" v-if="pageList.length > 0">
        <div class="pagination-info">
          <span>已查询: {{ totalQueriedCount }} 条</span>
          <span style="margin-left: 16px">至{{ currentPageIndex + 1 }}页共有: {{ totalCountToCurrentPage }} 条</span>
          <span style="margin-left: 16px">
            当前页数量: {{ dataSource.length }} 条
            <a-tag v-if="!hasMore" color="green" style="margin-left: 8px">查询完毕</a-tag>
            <a-tag v-else color="red" style="margin-left: 8px">未查询完毕</a-tag>
          </span>

        </div>
        <div class="pagination-content">
          <a-button
            :disabled="currentPageIndex === 0"
            @click="handlePrevPage"
            size="small"
          >
            上一页
          </a-button>
          <span
            v-for="(page, index) in pageList"
            :key="index"
            class="page-number"
            :class="{ active: currentPageIndex === index }"
            @click="handlePageClick(index)"
          >
            {{ index + 1 }}
          </span>
          <a-button
            :disabled="!hasMore"
            @click="handleNextPage"
            size="small"
          >
            下一页
          </a-button>
        </div>
      </div>
    </div>

    <!-- 详情弹窗 -->
    <a-modal
      :title="modalTitle"
      :visible="modalVisible"
      :width="800"
      :footer="null"
      @cancel="handleModalClose"
    >
      <div v-if="isBasicDataSync">
        <p><strong>基本信息：</strong></p>
        <pre class="log-content">{{ currentRecord.firstLine }}</pre>
        <p><strong>内容：</strong></p>
        <pre class="log-content">{{ currentRecord.keywordLine }}</pre>
      </div>
      <div v-else>
        <pre class="log-content">{{ detailContent }}</pre>
      </div>
    </a-modal>
  </a-card>
</template>

<script>
import { postAction } from '@/api/manage'
import moment from 'moment'

export default {
  name: 'GisSyncDataLogList',
  data() {
    return {
      // 日期范围（使用moment对象）
      dateRange: [],
      // 查询参数
      queryParam: {
        serverNo: '232',
        startTime: '',
        endTime: '',
        keyword: '',
        logType: undefined,
        configCode: '',
        lastFile: '',
        lastLine: 0
      },
      // 表格列定义
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '日志类型',
          align: 'center',
          dataIndex: 'logType',
          width: 120,
          scopedSlots: { customRender: 'logType' }
        },
        {
          title: '配置号',
          align: 'center',
          dataIndex: 'configCode',
          width: 120
        },
        {
          title: '基本信息',
          align: 'left',
          dataIndex: 'firstLine',
          ellipsis: true
        },
        {
          title: '内容',
          align: 'left',
          dataIndex: 'keywordLine',
          ellipsis: true
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          align: 'center',
          width: 100,
          fixed: 'right'
        }
      ],
      // 数据源
      dataSource: [],
      loading: false,
      // 分页相关
      hasMore: false,
      currentPageIndex: 0,
      pageList: [], // 保存每页的分页信息 [{lastFile, lastLine, lastFirstLine, count}]
      // 弹窗相关
      modalVisible: false,
      modalTitle: '日志详情',
      currentRecord: {},
      detailContent: '',
      isBasicDataSync: false,
      // API地址
      url: {
        list: '/log/query/list',
        detail: '/log/query/entry'
      }
    }
  },
  computed: {
    // 累计查询的总条数（所有已查询页面的总和）
    totalQueriedCount() {
      return this.pageList.reduce((sum, page) => sum + (page.count || 0), 0)
    },
    // 到当前页为止的累计条数
    totalCountToCurrentPage() {
      let count = 0
      for (let i = 0; i <= this.currentPageIndex && i < this.pageList.length; i++) {
        count += this.pageList[i].count || 0
      }
      return count
    }
  },
  mounted() {
    // 初始化默认时间
    this.initDefaultTime()
  },
  methods: {
    // 初始化默认时间（最近3小时）
    initDefaultTime() {
      const endTime = moment()
      const startTime = moment().subtract(3, 'hours')
      this.dateRange = [startTime, endTime]
      this.queryParam.startTime = startTime
      this.queryParam.endTime = endTime
    },
    // 日期变化处理
    handleDateChange(dates, dateStrings) {
      this.dateRange = dates
      this.queryParam.startTime = dates[0]
      this.queryParam.endTime = dates[1]
    },
    // 格式化时间
    formatTime(date) {
      if (!date) return ''
      return moment(date).format('YYYY-MM-DD HH:mm')
    },
    // 查询
    searchQuery() {
      // 重置分页
      this.currentPageIndex = 0
      this.pageList = []
      this.queryParam.lastFile = ''
      this.queryParam.lastLine = 0
      this.loadData()
    },
    // 重置
    searchReset() {
      this.queryParam = {
        serverNo: '232',
        startTime: null,
        endTime: null,
        keyword: '',
        logType: undefined,
        configCode: '',
        lastFile: '',
        lastLine: 0
      }
      this.dateRange = []
      this.initDefaultTime()
      this.searchQuery()
    },
    // 加载数据
    loadData() {
      this.loading = true
      const params = {
        serverNo: this.queryParam.serverNo,
        startTime: this.formatTime(this.queryParam.startTime),
        endTime: this.formatTime(this.queryParam.endTime),
        keyword: this.queryParam.keyword,
        logType: this.queryParam.logType,
        configCode: this.queryParam.configCode,
        lastFile: this.queryParam.lastFile,
        lastLine: this.queryParam.lastLine
      }
      postAction(this.url.list, params).then((res) => {
        if (res.success) {
          let list = res.result.list || []
          this.hasMore = res.result.hasMore

          // 切页时检查第一条数据是否需要删除（避免跨页重复）
          if (this.currentPageIndex > 0 && list.length > 0) {
            const prevPageInfo = this.pageList[this.currentPageIndex - 1]
            const firstRecord = list[0]
            // 如果第一条日志类型不是基础资料同步，且fileName和firstLineNumber与上一页最后一条相同，则删除
            if (firstRecord.logType !== '基础资料同步' &&
                firstRecord.fileName === prevPageInfo.lastFile &&
                firstRecord.firstLineNumber === prevPageInfo.lastFirstLine) {
              list.shift() // 删除第一条数据
            }
          }

          this.dataSource = list

          // 保存当前页的分页信息（即使为空列表也保存，避免最后一页为空的bug）
          const pageInfo = {
            lastFile: list.length > 0 ? list[list.length - 1].fileName : '',
            lastLine: list.length > 0 ? list[list.length - 1].lineNumber : 0,
            lastFirstLine: list.length > 0 ? list[list.length - 1].firstLineNumber : 0,
            count: list.length
          }

          // 如果是新查询或页码超出范围，添加新的分页信息
          if (this.pageList.length === 0 || this.currentPageIndex >= this.pageList.length) {
            if (this.currentPageIndex === this.pageList.length) {
              this.pageList.push(pageInfo)
            }
          } else {
            // 更新现有分页信息
            this.pageList[this.currentPageIndex] = pageInfo
          }
        } else {
          this.$message.warning(res.message)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 上一页
    handlePrevPage() {
      if (this.currentPageIndex > 0) {
        this.currentPageIndex--
        const pageInfo = this.pageList[this.currentPageIndex]
        if (this.currentPageIndex === 0) {
          // 第一页不需要lastFile和lastLine
          this.queryParam.lastFile = ''
          this.queryParam.lastLine = 0
        } else {
          const prevPageInfo = this.pageList[this.currentPageIndex - 1]
          this.queryParam.lastFile = prevPageInfo.lastFile
          this.queryParam.lastLine = prevPageInfo.lastLine
        }
        this.loadData()
      }
    },
    // 下一页
    handleNextPage() {
      if (this.hasMore) {
        this.currentPageIndex++
        const prevPageInfo = this.pageList[this.currentPageIndex - 1]
        this.queryParam.lastFile = prevPageInfo.lastFile
        this.queryParam.lastLine = prevPageInfo.lastLine
        this.loadData()
      }
    },
    // 点击页码
    handlePageClick(index) {
      if (index === this.currentPageIndex) return

      this.currentPageIndex = index
      if (index === 0) {
        this.queryParam.lastFile = ''
        this.queryParam.lastLine = 0
      } else {
        const prevPageInfo = this.pageList[index - 1]
        this.queryParam.lastFile = prevPageInfo.lastFile
        this.queryParam.lastLine = prevPageInfo.lastLine
      }
      this.loadData()
    },
    // 查看详情
    handleDetail(record) {
      this.currentRecord = record
      // 判断是否为"基础资料同步"类型
      this.isBasicDataSync = record.logType === '基础资料同步'

      if (this.isBasicDataSync) {
        // 基础资料同步直接显示列表中的内容
        this.modalTitle = '日志详情 - 基础资料同步'
        this.modalVisible = true
      } else {
        // 其他类型调用详情接口
        this.modalTitle = '日志详情'
        this.loadDetail(record)
      }
    },
    // 加载详情
    loadDetail(record) {
      const params = {
        serverNo: this.queryParam.serverNo,
        fileName: record.fileName,
        firstLineNumber: record.firstLineNumber
      }
      postAction(this.url.detail, params).then((res) => {
        if (res.success) {
          this.detailContent = res.result.content || ''
          this.modalVisible = true
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    // 关闭弹窗
    handleModalClose() {
      this.modalVisible = false
      this.currentRecord = {}
      this.detailContent = ''
      this.isBasicDataSync = false
    }
  }
}
</script>

<style scoped>
/* 自定义分页样式 */
.custom-pagination {
  margin-top: 16px;
  padding: 16px;
  text-align: center;
  background: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
}

.pagination-info {
  margin-bottom: 12px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
}

.pagination-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.page-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
  padding: 0 6px;
  margin: 0 4px;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 14px;
}

.page-number:hover {
  border-color: #1890ff;
  color: #1890ff;
}

.page-number.active {
  background: #1890ff;
  border-color: #1890ff;
  color: #fff;
}

/* 日志内容样式 */
.log-content {
  background: #f5f5f5;
  padding: 12px;
  border-radius: 4px;
  max-height: 400px;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-all;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 12px;
  line-height: 1.5;
}
</style>
